import React from "react";
import {FormControl, InputLabel, Select, MenuItem, Box, Typography, Card, CardContent, Grid} from "@mui/material";
import {useTenantTheme} from "../../themes/TenantThemeProvider";
import {tenantThemes} from "../../themes/tenantThemes";

interface ThemeSelectorProps {
  value?: string;
  onChange?: (theme: string) => void;
  showPreview?: boolean;
  label?: string;
  size?: "small" | "medium";
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ({value, onChange, showPreview = false, label = "Theme", size = "medium"}) => {
  const {tenant, setTenant, themeConfig} = useTenantTheme();

  const currentValue = value || tenant;
  const handleChange = onChange || setTenant;

  return (
    <Box>
      <FormControl fullWidth size={size}>
        <InputLabel>{label}</InputLabel>
        <Select value={currentValue} onChange={(e) => handleChange(e.target.value)} label={label}>
          {Object.entries(tenantThemes).map(([themeName, theme]) => (
            <MenuItem key={themeName} value={themeName}>
              {theme.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showPreview && currentValue && tenantThemes[currentValue] && (
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            Theme Preview
          </Typography>
          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Box
                      width={40}
                      height={40}
                      borderRadius="50%"
                      bgcolor={tenantThemes[currentValue].theme.palette.primary.main}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    />
                    <Box
                      width={40}
                      height={40}
                      borderRadius="50%"
                      bgcolor={tenantThemes[currentValue].theme.palette.secondary.main}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    />
                  </Box>
                </Grid>
                <Grid item xs>
                  <Typography variant="body2" color="text.secondary">
                    {tenantThemes[currentValue].description}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
};

export default ThemeSelector;
